












import { vxm } from '../../store.vuex';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { MultiListSelect } from 'vue-search-select';
import _ from 'lodash';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'MultipleSelectWithCheckbox',
  components: { MultiListSelect },
})
export default class MultipleSelectWithCheckbox extends Vue {
  $wlToastr: any;
  @Prop() list;
  @Prop() placeholder;
  @Prop() optionValue;
  @Prop() optionText;
  @Prop({ default: () => [] }) selectedItems;
  private searchText = ''; // If value is falsy, reset searchText & searchItem
  private items = [];
  private lastSelectItem = {};
  mounted() {
    console.log('MultipleSelectWithCheckbox : mounted');
    this.items = this.selectedItems;
  }

  onSelect(items, lastSelectItem) {
    this.items = items;
    this.lastSelectItem = lastSelectItem;
  }
  // deselect option
  reset() {
    this.items = []; // reset
  }
  // select option from parent component
  selectFromParentComponent() {
    this.items = _.unionWith(this.items, [this.list[0]], _.isEqual);
  }

  @Watch('items')
  onItemsChanges(value, oldValue) {
    this.$emit('selectedItemsChanged', value, oldValue);
  }
}
